module.exports = __webpack_public_path__ + "img/zghb.d0289dc0.png";